import { Box, IconButton } from "@mui/joy";
import { AddIcon } from "../../../styles/StyledMUI";
import DarkCard from "../../common/DarkCard";
import { ctaAccentColor, ctaAccentTextColor } from "../../../styles/globalStyles";

export type LeaveTypesHeaderProps = {
  onAdd: () => void;
  disabled?: boolean;
};

export default function LeaveTypesHeader({ onAdd, disabled = false }: LeaveTypesHeaderProps) {
  return (
    <DarkCard sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <IconButton
          type="button"
          onClick={onAdd}
          disabled={disabled}
          sx={{ backgroundColor: ctaAccentColor, color: ctaAccentTextColor }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </DarkCard>
  );
}
